import cl from 'clsx'
import { forwardRef, HTMLAttributes } from 'react'
import { ALL_STATUS_CONTENT, type DocumentStatus } from '../data'
import classes from './StatusBadge.module.scss'
import { cn } from '@/true-fsd/shared/utils/css'

export type StatusBadgeProps = {
    value: DocumentStatus
    showToaster?: string | boolean
} & Pick<HTMLAttributes<HTMLDivElement>, 'children' | 'className' | 'onClick'>

export const StatusBadge = forwardRef<HTMLDivElement, StatusBadgeProps>(
    function StatusBadge(
        { value, children, className, onClick, showToaster = false },
        forwardedRef
    ) {
        const { title, style } = ALL_STATUS_CONTENT[value]

        return (
            <div
                ref={forwardedRef}
                className={cl(classes.root, className)}
                onClick={onClick}
                style={style}
            >
                <div
                    className={cn(classes.text, showToaster && classes.toaster)}
                >
                    {title}
                </div>
                {children}
            </div>
        )
    }
)
